import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig } from '../../../../app.settings';
import { WallCalibrationModel } from '../../../shared/models/wall-calibration.type';
import { MonitorAdjustment } from '../models/monitor-adjustment.model';

@Injectable()
export class SpaceWallManagementService {

  private endpoint: string;

  constructor(
    public readonly httpClient: HttpClient,
    public readonly config: AppConfig
  ) {
    this.endpoint = `${this.config.getConfig('api')}walls/spacewall-management/`;
  }

  adjustMonitor(physicalAddress: string, monitorAdjustment: MonitorAdjustment): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}adjust-monitor/${physicalAddress}`, monitorAdjustment);
  }

  calibrateWall(physicalAddress: string, wallCalibrationModel: WallCalibrationModel): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}calibrate-wall/${physicalAddress}`, wallCalibrationModel);
  }
}
